import {motion, useReducedMotion} from 'motion/react';
import {Button} from '@/components/ui/button';
import {asset} from '@/lib/asset';
import {CTA_LABEL} from '@/lib/registration-window';

export type NavTarget = 'evento' | 'vendors' | 'recap' | 'registro';

// "Mapa" salió del menú junto con el mapa del evento; en su lugar va el recap
// del año pasado. Al reponer el mapa, este enlace vuelve a ser ["mapa", "Mapa"].
const LINKS: [NavTarget, string][] = [
  ['evento', 'El evento'],
  ['vendors', 'Comercios participantes'],
  ['recap', 'Edición 2025'],
];

export function SiteHeader({onNavigate}: {onNavigate: (t: NavTarget) => void}) {
  const reduced = useReducedMotion();
  return (
    <motion.header
      initial={reduced ? false : {y: -24, opacity: 0}}
      animate={{y: 0, opacity: 1}}
      transition={{duration: 0.6, ease: [0.16, 1, 0.3, 1]}}
      className="sticky top-0 z-50 border-b border-white/8 bg-pine-900/80 backdrop-blur-md"
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-4 sm:px-6">
        <a
          href={asset('')}
          aria-label="Navimarket 2026 — ir al inicio"
          className="shrink-0 rounded-md focus-visible:outline-2 focus-visible:outline-offset-4"
        >
          <img src={asset('img/logos/ath-movil-w.webp')} alt="ATH Móvil" className="h-7 w-auto" />
        </a>

        <nav aria-label="Secciones" className="hidden items-center gap-6 md:flex">
          {LINKS.map(([target, label]) => (
            <button
              key={target}
              type="button"
              onClick={() => {
                onNavigate(target);
              }}
              className="rounded-md text-sm text-cream/90 transition-colors hover:text-white focus-visible:outline-2 focus-visible:outline-offset-4"
            >
              {label}
            </button>
          ))}
        </nav>

        <Button
          onClick={() => {
            onNavigate('registro');
          }}
          className="rounded-full bg-tangerine px-5 font-medium text-white shadow-[0_4px_20px_-4px_rgba(222,118,57,0.5)] transition-all hover:-translate-y-px hover:bg-tangerine-deep"
        >
          {CTA_LABEL}
        </Button>
      </div>
    </motion.header>
  );
}
